import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import { flatten, deepen } from '../../versa/record.js';
import { notify } from '../../versa/msgbox.js';
import view from '../views/categories.js';
import form from '../forms/categories.js';
import * as types from '../types.js';

const categories = function()
{

	let categories_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_categories, query);
		},
		async loadRecord(id)
		{
			let _record = await api.call(api.select_category, ...JSON.parse(id));
			return flatten(_record, 'attributes');
		},
		async saveRecord(data, old_data)
		{
			data = deepen(data, 'attributes');
			let _record = {
				name: data.name,
				attributes: data.attributes.map((entry, index) => ({
					position: index + 1,
					name: entry.name,
					length: Number(entry.length),
					is_optional: entry.is_optional == '1'		// Can be: undefined, '0', '1'
				}))
			};
			if (old_data)
				return await api.call(api.update_category, data.company_id, data.id, _record);
			else
				return await api.call(api.insert_category, data.company_id, _record);
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Categoria', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador da categoria' },
		{ index: 3, field: 'name', label: 'Nome', types: [types.name()], placeholder: '', title: 'Nome da categoria' },
	];

	categories_crud.run(
		'categories',
		'Categorias',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs
	);

};

export default categories;

